var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course_content_wrapper"},[(_vm.hasActiveCourse)?_c('active-course-page',{attrs:{"course":_vm.course}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }